// Mock data for The Eternal Care Dental Clinic

export const clinicInfo = {
  name: "The Eternal Care",
  tagline: "Painless Dentistry, Powered by Human Touch",
  address: "72/30-A Patel Marg, Mansarovar, Jaipur-302020",
  phone: "+91 9256480329",
  email: "theeternalcare@gmail.com",
  workingHours: "All days, 10:00 AM – 8:00 PM",
  instagram: "https://www.instagram.com/the_eternal_care/",
  website: "www.theeternalcare.com",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.4!2d75.8!3d26.85!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjbCsDUxJzAwLjAiTiA3NcKwNDgnMDAuMCJF!5e0!3m2!1sen!2sin!4v1234567890"
};

export const doctor = {
  name: "Dr. Parmila Mahala",
  designation: "Dental Surgeon & Cosmetologist",
  image: "/dr-parmila.jpg",
  bio: "Dr. Parmila Mahala is a skilled Dental Surgeon and Cosmetologist known for her gentle, empathetic approach and expertise in painless dentistry. She combines advanced dental technology with compassionate care to ensure patient comfort, trust, and excellent clinical outcomes. With years of experience and continuous training in the latest dental techniques, Dr. Mahala is committed to providing personalized treatment plans that address each patient's unique needs while maintaining the highest standards of clinical excellence.",
  education: [
    "BDS - Bachelor of Dental Surgery",
    "Advanced Certification in Cosmetic Dentistry",
    "Specialized Training in Dental Implantology"
  ],
  specializations: [
    "Painless Dental Procedures",
    "Dental Implants",
    "Cosmetic Dentistry",
    "Clear Aligners",
    "Smile Designing"
  ]
};

export const services = [
  {
    id: "dental-implants",
    title: "Dental Implants",
    icon: "Smile",
    shortDesc: "Permanent solution for missing teeth with advanced implant systems",
    fullDesc: "Our dental implants provide a permanent, natural-looking solution for missing teeth. Using advanced implant systems and painless techniques, we restore your smile with results that look, feel, and function like natural teeth.",
    benefits: [
      "Permanent and long-lasting solution",
      "Natural look and feel",
      "Improved chewing function",
      "Prevents bone loss",
      "Enhanced facial structure",
      "Painless procedure with advanced techniques"
    ],
    procedure: [
      "Initial consultation and 3D imaging",
      "Customized treatment planning",
      "Painless implant placement",
      "Healing and osseointegration period",
      "Custom crown placement",
      "Follow-up care and maintenance"
    ],
    whoItsFor: [
      "Individuals with one or more missing teeth",
      "Those seeking permanent tooth replacement",
      "Patients with sufficient jawbone density",
      "Anyone wanting to restore their smile"
    ],
    image: "https://images.pexels.com/photos/6502343/pexels-photo-6502343.jpeg"
  },
  {
    id: "clear-aligners",
    title: "Clear Aligners",
    icon: "Zap",
    shortDesc: "Invisible orthodontic treatment for a perfect smile",
    fullDesc: "Transform your smile discreetly with our clear aligner treatment. Custom-designed invisible aligners gradually straighten your teeth without the need for traditional metal braces, offering comfort and convenience.",
    benefits: [
      "Virtually invisible appearance",
      "Removable for eating and cleaning",
      "Comfortable with no metal brackets",
      "Predictable results with 3D planning",
      "Shorter treatment time in many cases",
      "Minimal impact on daily life"
    ],
    procedure: [
      "Digital smile analysis and 3D scanning",
      "Custom treatment plan creation",
      "Fabrication of personalized aligners",
      "Wearing aligners 20-22 hours daily",
      "Regular progress monitoring",
      "Retention phase for lasting results"
    ],
    whoItsFor: [
      "Adults and teens seeking discreet orthodontic treatment",
      "Those with mild to moderate alignment issues",
      "Patients wanting removable orthodontic solution",
      "Anyone seeking a confident smile transformation"
    ],
    image: "https://images.unsplash.com/photo-1629909613654-28e377c37b09"
  },
  {
    id: "root-canal",
    title: "Root Canal Treatment",
    icon: "Heart",
    shortDesc: "Painless endodontic therapy to save your natural teeth",
    image: "https://images.unsplash.com/photo-1758206524132-72a2aa6639e2"
  },
  {
    id: "cosmetic-dentistry",
    title: "Cosmetic Dentistry",
    icon: "Sparkles",
    shortDesc: "Enhance your smile with advanced cosmetic procedures",
    image: "https://images.unsplash.com/photo-1675526607070-f5cbd71dde92"
  },
  {
    id: "teeth-whitening",
    title: "Teeth Whitening",
    icon: "Sun",
    shortDesc: "Professional whitening for a brighter, confident smile",
    image: "https://images.unsplash.com/photo-1684607633080-df59e6874367"
  },
  {
    id: "smile-designing",
    title: "Smile Designing",
    icon: "Star",
    shortDesc: "Custom smile makeovers tailored to your facial features",
    image: "https://images.unsplash.com/photo-1617812191081-2a24e3f30e45"
  },
  {
    id: "pediatric-dentistry",
    title: "Pediatric Dentistry",
    icon: "Baby",
    shortDesc: "Gentle, specialized dental care for children",
    image: "https://images.unsplash.com/photo-1770321119162-05c18fbcfdb9"
  },
  {
    id: "general-dentistry",
    title: "General Dentistry",
    icon: "Activity",
    shortDesc: "Comprehensive oral health care for the whole family",
    image: "https://images.pexels.com/photos/305567/pexels-photo-305567.jpeg"
  },
  {
    id: "emergency-care",
    title: "Emergency Dental Care",
    icon: "AlertCircle",
    shortDesc: "Immediate care for dental emergencies, available all days",
    image: "https://images.pexels.com/photos/6502635/pexels-photo-6502635.jpeg"
  }
];

export const whyChooseUs = [
  {
    title: "Painless Dentistry Protocols",
    description: "Our primary focus is ensuring every procedure is as comfortable and painless as possible using advanced techniques and gentle care.",
    icon: "Shield"
  },
  {
    title: "Empathetic Human Approach",
    description: "We prioritize patient comfort and trust with compassionate care that addresses your concerns and anxieties.",
    icon: "Heart"
  },
  {
    title: "Advanced Implant Systems",
    description: "State-of-the-art dental implant technology for superior results and faster healing.",
    icon: "Award"
  },
  {
    title: "International Sterilization Standards",
    description: "Strict adherence to global sterilization protocols ensuring the highest level of safety and hygiene.",
    icon: "CheckCircle"
  },
  {
    title: "Premium Technology",
    description: "Modern equipment and cutting-edge dental technology for precise diagnosis and treatment.",
    icon: "Zap"
  },
  {
    title: "Experienced Expertise",
    description: "Years of specialized experience in painless dentistry and cosmetic procedures.",
    icon: "Star"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Mansarovar, Jaipur",
    rating: 5,
    text: "I was terrified of dental procedures, but Dr. Parmila's gentle approach made my root canal completely painless. The care and empathy shown by the entire team at The Eternal Care is exceptional. Highly recommended!",
    treatment: "Root Canal Treatment",
    date: "November 2024"
  },
  {
    id: 2,
    name: "Rajesh Verma",
    location: "Malviya Nagar, Jaipur",
    rating: 5,
    text: "Got my dental implants done here and I'm amazed by the results. The procedure was painless and the clinic maintains excellent hygiene standards. Dr. Mahala explained everything clearly. Best dental clinic in Jaipur!",
    treatment: "Dental Implants",
    date: "October 2024"
  },
  {
    id: 3,
    name: "Anita Gupta",
    location: "Vaishali Nagar, Jaipur",
    rating: 5,
    text: "The clear aligners treatment has transformed my smile! The entire process was smooth, comfortable, and the results are beyond my expectations. Thank you Dr. Parmila for the amazing care and attention.",
    treatment: "Clear Aligners",
    date: "December 2024"
  },
  {
    id: 4,
    name: "Vikram Singh",
    location: "Jaipur",
    rating: 5,
    text: "Professional, caring, and truly painless! I had multiple dental issues and the team handled everything with such expertise. The clinic is modern, clean, and the staff is very friendly. Grateful for their service.",
    treatment: "General Dentistry",
    date: "September 2024"
  }
];

export const blogPosts = [
  {
    id: 1,
    slug: "complete-guide-painless-dentistry-jaipur",
    title: "The Complete Guide to Painless Dentistry in Jaipur",
    category: "Painless Dentistry",
    excerpt: "Dental fear is real. At The Eternal Care, we believe dentistry should never be associated with pain. Learn how modern painless dental treatment works in Jaipur.",
    image: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHw0fHxkZW50YWwlMjBjbGluaWN8ZW58MHx8fHwxNzcwNzI3MTIzfDA&ixlib=rb-4.1.0&q=85",
    author: "Dr. Parmila Mahala",
    date: "December 15, 2024",
    readTime: "8 min read",
    content: `
      <h2>Introduction</h2>
      <p>Dental fear is real. For many people in Jaipur, just the thought of visiting a dentist causes anxiety.</p>
      <p>At <strong>The Eternal Care, Mansarovar, Jaipur</strong>, we believe dentistry should never be associated with pain. Our vision is simple:</p>
      <blockquote><strong>Painless Dentistry, Powered by Human Touch.</strong></blockquote>
      <p>This guide explains how modern painless dental treatment works, what technologies are used, and how you can experience stress-free dentistry in Jaipur.</p>
      
      <h2>What Is Painless Dentistry?</h2>
      <p>Painless dentistry is not just about anesthesia. It includes:</p>
      <ul>
        <li>Advanced numbing techniques</li>
        <li>Modern equipment</li>
        <li>Gentle procedural protocols</li>
        <li>Fear management</li>
        <li>Empathetic communication</li>
        <li>Sterilization safety</li>
        <li>Minimal invasive techniques</li>
      </ul>
      <p>At our Mansarovar clinic, every treatment is designed to reduce pain, anxiety, post-treatment discomfort, and recovery time.</p>
      
      <h2>Why Do People Fear Dental Treatment?</h2>
      <p>Common reasons include:</p>
      <ul>
        <li>Previous painful experience</li>
        <li>Fear of injections</li>
        <li>Sound of drills</li>
        <li>Sensitivity issues</li>
        <li>Fear of complications</li>
      </ul>
      <p>As a <strong>Painless Dentist in Jaipur</strong>, Dr. Parmila Mahala focuses on emotional comfort as much as clinical precision.</p>
      
      <h2>Technologies That Make Dentistry Painless</h2>
      <h3>1. Advanced Local Anesthesia Techniques</h3>
      <ul>
        <li>Slow controlled delivery</li>
        <li>Topical numbing gel before injection</li>
        <li>Thin, modern needles</li>
      </ul>
      
      <h3>2. Modern Rotary Systems (for Root Canal)</h3>
      <ul>
        <li>Faster</li>
        <li>More precise</li>
        <li>Less discomfort</li>
      </ul>
      
      <h3>3. Digital X-Rays</h3>
      <ul>
        <li>Minimal radiation</li>
        <li>Faster diagnosis</li>
        <li>Comfortable process</li>
      </ul>
      
      <h3>4. Advanced Implant Systems</h3>
      <p>For patients needing <strong>Dental Implants in Jaipur</strong>, we use:</p>
      <ul>
        <li>Precision-guided placement</li>
        <li>Minimal invasive surgical approach</li>
        <li>Faster healing</li>
      </ul>
      
      <h2>Painless Treatments Available at The Eternal Care</h2>
      <ul>
        <li>✔ Painless Root Canal Treatment</li>
        <li>✔ Single Sitting RCT</li>
        <li>✔ Dental Implants</li>
        <li>✔ Clear Aligners</li>
        <li>✔ Smile Makeovers</li>
        <li>✔ Teeth Whitening</li>
        <li>✔ Gum Treatment</li>
        <li>✔ Cosmetic Dentistry</li>
      </ul>
      <p>All performed under strict sterilization protocols.</p>
      
      <h2>Our Sterilization & Safety Standards</h2>
      <p>We follow:</p>
      <ul>
        <li>International sterilization standards</li>
        <li>Autoclave sterilization</li>
        <li>Disposable instruments wherever required</li>
        <li>Barrier protection protocols</li>
      </ul>
      <p><strong>Patient safety = Zero compromise.</strong></p>
      
      <h2>How We Add the "Human Touch"</h2>
      <p>What truly makes us different in Mansarovar:</p>
      <ul>
        <li>We explain every step before starting</li>
        <li>We allow patient-controlled pauses</li>
        <li>We maintain a calm environment</li>
        <li>We prioritise empathy</li>
        <li>We focus on pain prevention, not just pain control</li>
      </ul>
      <p>That's why many consider us among the <strong>Best Dentists in Mansarovar</strong>.</p>
      
      <h2>Is Painless Dentistry Really Pain-Free?</h2>
      <p>You may feel:</p>
      <ul>
        <li>Mild pressure</li>
        <li>Slight vibration</li>
        <li>Temporary numbness</li>
      </ul>
      <p>But you should NOT feel sharp pain. If you do — we immediately address it.</p>
      <p><strong>Your comfort is our first priority.</strong></p>
      
      <h2>Cost of Painless Dental Treatment in Jaipur</h2>
      <p>Cost depends on:</p>
      <ul>
        <li>Type of procedure</li>
        <li>Complexity</li>
        <li>Materials used</li>
      </ul>
      <p>At The Eternal Care:</p>
      <ul>
        <li>Transparent pricing</li>
        <li>Detailed consultation</li>
        <li>No hidden charges</li>
      </ul>
      
      <h2>Why Choose The Eternal Care, Mansarovar?</h2>
      <ul>
        <li>✔ Premium clinic ambiance</li>
        <li>✔ Advanced implant systems</li>
        <li>✔ Empathetic care</li>
        <li>✔ Focus on painless protocols</li>
        <li>✔ Located in Mansarovar, Jaipur</li>
      </ul>
      
      <h2>Frequently Asked Questions</h2>
      <h3>Q1. Is painless root canal truly painless?</h3>
      <p>Yes, with modern anesthesia and rotary systems, discomfort is minimal.</p>
      
      <h3>Q2. Are dental implants painful?</h3>
      <p>Implant surgery is done under anesthesia. Mild soreness for a few days is normal.</p>
      
      <h3>Q3. How do I book an appointment?</h3>
      <p>Call <strong>9256480329</strong> or book online through our website.</p>
      
      <h2>Final Words</h2>
      <p>If you are searching for:</p>
      <ul>
        <li>Painless Dentist Jaipur</li>
        <li>Best Dentist in Mansarovar</li>
        <li>Dental Implants in Jaipur</li>
      </ul>
      <p>Your search ends here.</p>
      <p><strong>👉 Book Your Consultation Today</strong></p>
      <p>📍 72/30-A Patel Marg, Mansarovar, Jaipur<br/>
      📞 9256480329<br/>
      📲 WhatsApp Available<br/>
      🌐 www.theeternalcare.com</p>
    `
  },
  {
    id: 2,
    slug: "dental-implants-jaipur-complete-guide",
    title: "Dental Implants in Jaipur: The Complete Guide to Permanent Tooth Replacement",
    category: "Dental Implants",
    excerpt: "Missing teeth don't just affect your smile — they affect your confidence and health. Learn everything about dental implants in Jaipur, from procedure to cost.",
    image: "https://images.pexels.com/photos/6502343/pexels-photo-6502343.jpeg",
    author: "Dr. Parmila Mahala",
    date: "December 12, 2024",
    readTime: "10 min read",
    content: `
      <h2>Introduction</h2>
      <p>Missing teeth don't just affect your smile — they affect your confidence, chewing ability, jaw health, and facial structure.</p>
      <p>If you are searching for <strong>Dental Implants in Jaipur</strong>, this complete guide will help you understand what dental implants are, whether they are painful, how long they last, cost factors, and why choosing the right implant dentist matters.</p>
      <p>At <strong>The Eternal Care, Mansarovar</strong>, we specialize in advanced, minimally invasive implant systems designed for precision and comfort.</p>
      
      <h2>What Are Dental Implants?</h2>
      <p>A dental implant is a titanium post surgically placed into the jawbone to replace the root of a missing tooth. It acts as a strong foundation for:</p>
      <ul>
        <li>Single crowns</li>
        <li>Bridges</li>
        <li>Full mouth rehabilitation</li>
      </ul>
      <p>Unlike dentures, implants are permanent and feel like natural teeth.</p>
      
      <h2>Why Choose Dental Implants Over Dentures?</h2>
      <table border="1" style="width: 100%; border-collapse: collapse;">
        <tr>
          <th>Dental Implants</th>
          <th>Dentures</th>
        </tr>
        <tr>
          <td>Permanent</td>
          <td>Removable</td>
        </tr>
        <tr>
          <td>No slipping</td>
          <td>Can move while eating</td>
        </tr>
        <tr>
          <td>Preserve jawbone</td>
          <td>Bone loss continues</td>
        </tr>
        <tr>
          <td>Natural look & feel</td>
          <td>Less stable</td>
        </tr>
      </table>
      <p><strong>Implants are the gold standard for tooth replacement.</strong></p>
      
      <h2>Are Dental Implants Painful?</h2>
      <p>This is the most common question.</p>
      <p>At The Eternal Care, we follow <strong>painless dentistry protocols</strong>:</p>
      <ul>
        <li>Local anesthesia for complete numbness</li>
        <li>Minimally invasive surgical technique</li>
        <li>Advanced implant placement systems</li>
        <li>Gentle post-operative care</li>
      </ul>
      <p>Most patients say implant placement is easier than tooth extraction.</p>
      
      <h2>Who Is a Candidate for Dental Implants?</h2>
      <p>You may be eligible if you:</p>
      <ul>
        <li>✔ Have one or more missing teeth</li>
        <li>✔ Have healthy gums</li>
        <li>✔ Have sufficient jawbone</li>
        <li>✔ Want a long-term solution</li>
      </ul>
      <p>A consultation with <strong>Dr. Parmila Mahala</strong> will determine suitability.</p>
      
      <h2>Step-by-Step Implant Procedure</h2>
      <ol>
        <li><strong>Step 1:</strong> Consultation & Digital X-rays</li>
        <li><strong>Step 2:</strong> Treatment Planning</li>
        <li><strong>Step 3:</strong> Implant Placement</li>
        <li><strong>Step 4:</strong> Healing Phase (3–4 months)</li>
        <li><strong>Step 5:</strong> Crown Placement</li>
      </ol>
      <p>The result? A natural, confident smile.</p>
      
      <h2>How Long Do Dental Implants Last?</h2>
      <p>With proper care:</p>
      <ul>
        <li>15–25 years</li>
        <li>Often lifetime</li>
      </ul>
      <p>Good oral hygiene and regular dental visits are key.</p>
      
      <h2>Cost of Dental Implants in Jaipur</h2>
      <p>Cost depends on:</p>
      <ul>
        <li>Number of implants</li>
        <li>Bone grafting (if needed)</li>
        <li>Type of implant system</li>
        <li>Crown material</li>
      </ul>
      <p>At The Eternal Care:</p>
      <ul>
        <li>Transparent pricing</li>
        <li>Detailed explanation</li>
        <li>Premium quality materials</li>
      </ul>
      
      <h2>Why Choose The Eternal Care for Implants in Mansarovar?</h2>
      <ul>
        <li>✔ Advanced implant systems</li>
        <li>✔ Painless surgical protocols</li>
        <li>✔ High sterilization standards</li>
        <li>✔ Premium clinic environment</li>
        <li>✔ Personalized care</li>
      </ul>
      <p>If you are looking for the <strong>Best Dentist in Mansarovar for Dental Implants</strong>, we are here for you.</p>
      
      <h2>FAQs</h2>
      <h3>Q1. How long does implant surgery take?</h3>
      <p>Usually 30–60 minutes per implant.</p>
      
      <h3>Q2. Is recovery painful?</h3>
      <p>Mild swelling or soreness for a few days is normal.</p>
      
      <h3>Q3. Can older patients get implants?</h3>
      <p>Yes, age is not a restriction if health permits.</p>
      
      <h2>Ready to Restore Your Smile?</h2>
      <p>📍 72/30-A Patel Marg, Mansarovar, Jaipur<br/>
      📞 9256480329<br/>
      🌐 www.theeternalcare.com</p>
      <p><strong>👉 Book Your Implant Consultation Today</strong></p>
    `
  },
  {
    id: 3,
    slug: "clear-aligners-jaipur-invisible-braces",
    title: "Clear Aligners in Jaipur: The Modern Way to Straighten Teeth Without Braces",
    category: "Clear Aligners",
    excerpt: "Metal braces are no longer the only option. Discover clear aligners - the discreet, comfortable solution for straightening teeth in Jaipur.",
    image: "https://images.unsplash.com/photo-1629909613654-28e377c37b09",
    author: "Dr. Parmila Mahala",
    date: "December 10, 2024",
    readTime: "7 min read",
    content: `
      <h2>Introduction</h2>
      <p>Metal braces are no longer the only option for straightening teeth.</p>
      <p>If you want a discreet, comfortable solution, <strong>Clear Aligners in Jaipur</strong> are the modern choice.</p>
      <p>At <strong>The Eternal Care, Mansarovar</strong>, we offer advanced invisible aligner solutions designed for comfort, aesthetics, and predictable results.</p>
      
      <h2>What Are Clear Aligners?</h2>
      <p>Clear aligners are:</p>
      <ul>
        <li>Transparent trays</li>
        <li>Custom-made</li>
        <li>Removable</li>
        <li>Nearly invisible</li>
      </ul>
      <p>They gradually shift teeth into proper alignment.</p>
      
      <h2>Why Choose Aligners Over Braces?</h2>
      <table border="1" style="width: 100%; border-collapse: collapse;">
        <tr>
          <th>Clear Aligners</th>
          <th>Traditional Braces</th>
        </tr>
        <tr>
          <td>Nearly invisible</td>
          <td>Visible metal</td>
        </tr>
        <tr>
          <td>Removable</td>
          <td>Fixed</td>
        </tr>
        <tr>
          <td>Easier to clean</td>
          <td>Difficult hygiene</td>
        </tr>
        <tr>
          <td>More comfortable</td>
          <td>Can cause irritation</td>
        </tr>
      </table>
      <p><strong>Aligners are ideal for working professionals and adults.</strong></p>
      
      <h2>Are Clear Aligners Painful?</h2>
      <p>No sharp pain.</p>
      <p>You may feel:</p>
      <ul>
        <li>Mild pressure when switching trays</li>
        <li>Temporary tightness</li>
      </ul>
      <p>At The Eternal Care, we ensure:</p>
      <ul>
        <li>✔ Proper planning</li>
        <li>✔ Smooth tray transitions</li>
        <li>✔ Continuous monitoring</li>
      </ul>
      
      <h2>What Problems Can Aligners Fix?</h2>
      <ul>
        <li>✔ Crowded teeth</li>
        <li>✔ Gaps</li>
        <li>✔ Overbite</li>
        <li>✔ Underbite</li>
        <li>✔ Crossbite</li>
        <li>✔ Mild to moderate misalignment</li>
      </ul>
      
      <h2>Treatment Duration</h2>
      <p>Usually: <strong>6 to 18 months</strong></p>
      <p>Depends on complexity.</p>
      
      <h2>How the Process Works</h2>
      <ol>
        <li>1️⃣ Consultation</li>
        <li>2️⃣ Digital Scanning</li>
        <li>3️⃣ Treatment Plan Preview</li>
        <li>4️⃣ Aligner Fabrication</li>
        <li>5️⃣ Regular Follow-ups</li>
      </ol>
      
      <h2>Why Choose The Eternal Care for Aligners in Jaipur?</h2>
      <ul>
        <li>✔ Premium consultation experience</li>
        <li>✔ Painless, empathetic approach</li>
        <li>✔ Modern scanning technology</li>
        <li>✔ Individualized treatment planning</li>
      </ul>
      <p>If you're searching for <strong>Invisible Aligners in Jaipur</strong> or the <strong>Best Dentist in Mansarovar for Aligners</strong>, we are here.</p>
      
      <h2>Cost of Clear Aligners in Jaipur</h2>
      <p>Cost depends on:</p>
      <ul>
        <li>Complexity</li>
        <li>Duration</li>
        <li>Brand used</li>
      </ul>
      <p>We provide detailed consultation and transparent pricing.</p>
      
      <h2>FAQs</h2>
      <h3>Q1. Can I remove aligners while eating?</h3>
      <p>Yes.</p>
      
      <h3>Q2. Are they suitable for teenagers?</h3>
      <p>Yes, depending on case evaluation.</p>
      
      <h3>Q3. Will people notice them?</h3>
      <p>Most people won't.</p>
      
      <h2>Transform Your Smile Discreetly</h2>
      <p>📍 72/30-A Patel Marg, Mansarovar, Jaipur<br/>
      📞 9256480329<br/>
      📲 WhatsApp Available</p>
      <p><strong>👉 Book Your Smile Consultation Today</strong></p>
    `
  },
  {
    id: 4,
    title: "Daily Oral Hygiene Tips for a Healthy Smile",
    category: "Oral Hygiene",
    slug: "daily-oral-hygiene-tips",
    excerpt: "Essential daily oral care practices to maintain optimal dental health. Simple habits that can prevent cavities, gum disease, and keep your smile bright.",
    image: "https://images.unsplash.com/photo-1617812191081-2a24e3f30e45",
    author: "Dr. Parmila Mahala",
    date: "November 28, 2024",
    readTime: "4 min read"
  },
  {
    id: 5,
    title: "Cosmetic Dentistry: Transforming Smiles with Confidence",
    category: "Cosmetic Dentistry",
    slug: "cosmetic-dentistry-smile-transformation",
    excerpt: "Explore the various cosmetic dentistry options available to enhance your smile. From whitening to veneers, discover what's right for you.",
    image: "https://images.unsplash.com/photo-1675526607070-f5cbd71dde92",
    author: "Dr. Parmila Mahala",
    date: "November 20, 2024",
    readTime: "8 min read"
  },
  {
    id: 6,
    title: "When to Seek Emergency Dental Care",
    category: "Dental Tips",
    slug: "emergency-dental-care-guide",
    excerpt: "Learn to recognize dental emergencies and understand when immediate professional care is necessary. Quick action can save your teeth.",
    image: "https://images.pexels.com/photos/6502635/pexels-photo-6502635.jpeg",
    author: "Dr. Parmila Mahala",
    date: "November 15, 2024",
    readTime: "5 min read"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://images.unsplash.com/photo-1675526607070-f5cbd71dde92",
    title: "Smile Transformation",
    category: "Results"
  },
  {
    id: 2,
    url: "https://images.pexels.com/photos/6502343/pexels-photo-6502343.jpeg",
    title: "Dental Implant Model",
    category: "Implants"
  },
  {
    id: 3,
    url: "https://images.pexels.com/photos/6812500/pexels-photo-6812500.jpeg",
    title: "Advanced Technology",
    category: "Equipment"
  },
  {
    id: 4,
    url: "https://images.unsplash.com/photo-1684607633080-df59e6874367",
    title: "Professional Treatment",
    category: "Procedures"
  },
  {
    id: 5,
    url: "https://images.unsplash.com/photo-1617812191081-2a24e3f30e45",
    title: "Beautiful Results",
    category: "Results"
  },
  {
    id: 6,
    url: "https://images.unsplash.com/photo-1679911522750-aeedd9c88550",
    title: "Treatment Outcome",
    category: "Results"
  },
  {
    id: 7,
    url: "https://images.pexels.com/photos/305567/pexels-photo-305567.jpeg",
    title: "Modern Clinic",
    category: "Facility"
  },
  {
    id: 8,
    url: "https://images.unsplash.com/photo-1643660526741-094639fbe53a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxkZW50YWwlMjBjbGluaWN8ZW58MHx8fHwxNzcwNzI3MTIzfDA&ixlib=rb-4.1.0&q=85",
    title: "Premium Environment",
    category: "Facility"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Is dental treatment really painless?",
    answer: "Yes! At The Eternal Care, we use advanced painless dentistry techniques including local anesthesia, sedation options, and gentle procedures to ensure your comfort throughout treatment. Our primary focus is making every visit as comfortable as possible."
  },
  {
    id: 2,
    question: "How long do dental implants last?",
    answer: "With proper care and maintenance, dental implants can last a lifetime. They are designed to be a permanent solution for missing teeth. Regular dental checkups and good oral hygiene are essential for long-term success."
  },
  {
    id: 3,
    question: "What is the duration of clear aligner treatment?",
    answer: "Clear aligner treatment typically takes 6-18 months depending on the complexity of your case. During your consultation, we'll provide a personalized timeline based on your specific needs and goals."
  },
  {
    id: 4,
    question: "Do you accept insurance?",
    answer: "We work with most dental insurance providers. Please contact us with your insurance details, and our team will help verify your coverage and benefits."
  },
  {
    id: 5,
    question: "What should I do in a dental emergency?",
    answer: "Call us immediately at +91 9256480329. We provide emergency dental care all days from 10 AM to 8 PM. For after-hours emergencies, leave a message and we'll respond as soon as possible."
  }
];
